"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsPanel = exports.Tab = exports.TabsContext = void 0;
var react_1 = __importStar(require("react"));
var hooks_1 = require("./hooks");
var styles_1 = require("./styles");
exports.TabsContext = react_1.createContext({});
function Tabs(_a) {
    var value = _a.value, onClick = _a.onClick, children = _a.children;
    return (react_1.default.createElement(exports.TabsContext.Provider, { value: { value: value, onClick: onClick } },
        react_1.default.createElement(styles_1.TabsSliderContainer, null, children)));
}
exports.default = Tabs;
function Tab(_a) {
    var value = _a.value, children = _a.children;
    var _b = hooks_1.useTabs(), selectedValue = _b.value, onClick = _b.onClick;
    var active = selectedValue === value;
    return (react_1.default.createElement(styles_1.TabContainer, { active: active, onClick: function () { return onClick(value); } }, children));
}
exports.Tab = Tab;
function TabsPanel(_a) {
    var value = _a.value, index = _a.index, children = _a.children;
    if (value !== index)
        return null;
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.TabsPanel = TabsPanel;
Tabs.Tab = Tab;
Tabs.Panel = TabsPanel;
//# sourceMappingURL=index.js.map